<template>
  <section class="py-12 px-4 bg-stone-50 dark:bg-stone-900">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div class="flex justify-center">
          <whatIsSpinTheNamesCard />
        </div>
        <div class="flex justify-center">
          <howToUseSpinTheNamesCard />
        </div>
        <div class="flex justify-center">
          <popularUsesCard />
        </div>
        <div class="flex justify-center">
          <whyUsersLoveCard />
        </div>
        <div class="flex justify-center">
          <userTestimonialsCard />
        </div>
        <div class="flex justify-center">
          <getStartedCard />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import howToUseSpinTheNamesCard from './howToUseSpinTheNamesCard.vue';
import popularUsesCard from './popularUsesCard.vue';
import whatIsSpinTheNamesCard from './whatIsSpinTheNamesCard.vue';
import whyUsersLoveCard from './whyUsersLoveCard.vue';
import getStartedCard from './getStartedCard.vue';
import userTestimonialsCard from './userTestimonialsCard.vue';
</script>
